class FpCategoryMenu {
  constructor(root) {
    this.root = root;
    this.trigger = root.querySelector('[data-fp-category-menu-trigger]');
    this.items = Array.from(root.querySelectorAll('[data-fp-category-menu-item]'));
    this.isHomepage = root.classList.contains('fp-category-menu--open');
    this.closeTimer = null;
    this.lastScrollY = window.scrollY || 0;
    this.scrollThreshold = 0;
    this.scrollFrame = null;
  }

  init() {
    if (!this.trigger) return;

    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle();
    });

    this.root.addEventListener('mouseenter', () => {
      window.clearTimeout(this.closeTimer);
    });

    this.root.addEventListener('mouseleave', () => {
      this.closeTimer = window.setTimeout(() => {
        if (!this.isHomepage) this.close();
        this.clearActiveItems();
      }, 120);
    });

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', () => this.activateItem(item));
      item.addEventListener('focusin', () => this.activateItem(item));
    });

    document.addEventListener('click', (event) => {
      if (!this.root.contains(event.target) && !this.isHomepage) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.isHomepage) {
        this.close();
        this.trigger.focus();
      }
    });

    if (this.isHomepage) {
      this.updateScrollThreshold();
      this.syncHomepageScrollState();

      window.addEventListener('resize', () => {
        this.updateScrollThreshold();
        this.syncHomepageScrollState();
      });

      window.addEventListener(
        'scroll',
        () => {
          if (this.scrollFrame) return;

          this.scrollFrame = window.requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.syncHomepageScrollState();
          });
        },
        { passive: true }
      );
    }
  }

  toggle() {
    if (this.isHomepage && this.root.classList.contains('is-scroll-hidden')) {
      this.showHomepageMenu();
      return;
    }

    if (this.root.classList.contains('is-open')) {
      if (!this.isHomepage) this.close();
      return;
    }

    this.open();
  }

  open() {
    this.root.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.root.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.clearActiveItems();
  }

  activateItem(activeItem) {
    this.items.forEach((item) => {
      item.classList.toggle('is-active', item === activeItem);
    });
  }

  clearActiveItems() {
    this.items.forEach((item) => item.classList.remove('is-active'));
  }

  updateScrollThreshold() {
    this.scrollThreshold = Math.max(400, Math.round(window.innerHeight * 0.18));
  }

  syncHomepageScrollState() {
    const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;

    if (currentScrollY > this.scrollThreshold) {
      this.hideHomepageMenu();
    } else {
      this.showHomepageMenu();
    }

    this.lastScrollY = currentScrollY;
  }

  hideHomepageMenu() {
    this.root.classList.add('is-scroll-hidden');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.clearActiveItems();
  }

  showHomepageMenu() {
    this.root.classList.remove('is-scroll-hidden');
    this.trigger.setAttribute('aria-expanded', 'true');
  }
}

class FpCategoryMenuRegistry {
  constructor() {
    this.instances = new WeakMap();
  }

  init(scope = document) {
    scope.querySelectorAll('[data-fp-category-menu]').forEach((root) => {
      if (this.instances.has(root)) return;

      const instance = new FpCategoryMenu(root);
      this.instances.set(root, instance);
      instance.init();
    });
  }
}

window.fpCategoryMenuRegistry = window.fpCategoryMenuRegistry || new FpCategoryMenuRegistry();

document.addEventListener('DOMContentLoaded', () => {
  window.fpCategoryMenuRegistry.init();
});

document.addEventListener('shopify:section:load', (event) => {
  window.fpCategoryMenuRegistry.init(event.target);
});
